import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  Optional,
  SimpleChanges,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { APIService } from '../../../../services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
// import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  standalone: false,
})
export class FormComponent {
  @Input() title: string = '';
  @Input() submitButtonLabel: string = 'Submit';
  @Input() isEducationLevelRequired: boolean = true;
  @Input() id;
  @Input() school;
  @Output() close = new EventEmitter<void>();
  isSameNo: boolean = false;
  // @Output() submitForm = new EventEmitter<any>();

  formData: any = {
    studentName: '',
    parentName: '',
    mobile: null,
    emailId: '',
    className: null,
    schoolId: this.data.id,
    whatsAppNo: '',
  };

  classList = [
    'LKG',
    'UKG',
    'First',
    'Second',
    'Third',
    'Forth',
    'Fifth',
    'Sixth',
    'Seventh',
    'Eighth',
    'Nineth',
    'Tenth',
    'Eleventh',
    'Twelveth',
  ];

  constructor(
    public dialogRef: MatDialogRef<FormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: APIService,
    public deviceDetectorService: DeviceDetectorService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    if (this.data.id) {
      this.formData.schoolId = this.data.id;
    } else {
      this.formData.schoolId = 0;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['school'] && changes['school'].currentValue) {
      console.log('school new data loaded', this.school);
      this.formData.schoolId = this.id;
    }
  }

  resetForm() {
    this.formData = {
      studentName: '',
      parentName: '',
      mobile: null,
      emailId: '',
      className: null,
      schoolId: this.id,
      whatsAppNo: '',
    };
  }

  setClassRange(): void {
    if (this.school.category.length) {
      if (this.isCategorySelected('Secondary education')) {
        this.classList = this.classList.slice(0, 10);
      } else if (this.isCategorySelected('Primary education')) {
        this.classList = this.classList.slice(0, 7);
      } else if (this.isCategorySelected('Pre-primary education')) {
        this.classList = this.classList.slice(0, 3);
      }
    }
  }

  isCategorySelected(categoryName: string): boolean {
    return this.school.category?.some(
      (item) => item.name === categoryName && item.selected
    );
  }

  isNumber(val) {
    if (val) return /^\d+$/.test(val + '');
    return false;
  }

  waNoSelected(event: MatCheckboxChange) {
    this.isSameNo = event.checked;
    this.formData.whatsAppNo = this.isSameNo ? this.formData.mobile : '';
  }

  submitForm(): void {
    // this.formData.schoolId = this.id;
    // console.log(this.formData.schoolId);
    // console.log('this isnt changing');
    // console.log('Form submitted:', this.formData);
    this.dialogRef.close(this.formData);
    this.api.createAdmissionEnquiry(this.formData).subscribe(
      (res) => {
        this._snackBar.open('Your details are submitted!', '', {
          duration: 6000,
        });
        this.resetForm();
      },
      (err) => {
        console.error('API Error:', err);
        this._snackBar.open('Your details are not submitted!', 'Resend', {
          duration: 6000,
        });
        this.resetForm();
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  submitDetails() {
    if (!this.isNumber(this.formData.mobile)) {
      this._snackBar.open('Invalid mobile no!', 'OK', {
        duration: 6000,
      });
      return;
    }
    // this.api.createAdmissionEnquiry(this.formData).subscribe(
    //   (res) => {
    //     this._snackBar.open('Your details are submitted!', '', {
    //       duration: 6000,
    //     });
    //     this.resetForm();
    //   },
    //   (err) => {
    //     console.error('API Error:', err);
    //     this._snackBar.open('Your details are not submitted!', 'Resend', {
    //       duration: 6000,
    //     });
    //     this.resetForm();
    //   }
    // );
  }

  closeModal() {
    this.close.emit();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
